<template>
  <label class="sorting-select">
    <vb-select
      @change="(value) => $emit('order', value)"
      :value="sort"
      :vb_options="{
        options: options,
        value: sort,
      }"
    />
  </label>
</template>

<script>
import { SORT_OPTIONS } from '@alpitour/utilities/results-sorting'

export default {
  name: "sorting-select",
  props: {
    sort: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      options: SORT_OPTIONS,
    }
  },
}
</script>

<style lang="scss" scoped>
.sorting-select {
  display: flex;
  margin: 0;
}
</style>
